import React from 'react';
import { useTranslation } from 'react-i18next';
import FeaturedSectionStats from '../../ui/FeaturedSectionStats';
import './IntroSectionCyberIncident.css';

const IntroSectionCyberIncident3: React.FC = () => {
  const { t } = useTranslation();

  // Data for FeaturedSectionStats specific to Cyber Incident
  const cyberIncidentStats = [
    {
      value: '24/7',
      label: 'Intervention d\'urgence',
      translationKey: 'incidentCyber.stats.emergency',
      labelTranslationKey: 'incidentCyber.stats.emergencyLabel'
    },
    {
      value: '<1h',
      label: 'Temps de réponse',
      translationKey: 'incidentCyber.stats.response',
      labelTranslationKey: 'incidentCyber.stats.responseLabel'
    },
    {
      value: '100%',
      label: 'Confinement garanti',
      translationKey: 'incidentCyber.stats.containment',
      labelTranslationKey: 'incidentCyber.stats.containmentLabel'
    },
    {
      value: '∞',
      label: 'Expertise technique',
      translationKey: 'incidentCyber.stats.expertise',
      labelTranslationKey: 'incidentCyber.stats.expertiseLabel'
    }
  ];

  return (
    <div className="intro-section-home intro-section-cyber-incident">
      <div className="intro-row-1 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 tw-items-center tw-pt-[4em] max-[734px]:tw-pt-0">
        <div className="intro-text-1">
          <h2 style={{ fontSize: '62px', paddingBottom: '12px' }}>{t('incidentCyber.introSection.commitment', 'Notre engagement')}</h2>
        </div>
      </div>

      <FeaturedSectionStats
        title="Une réponse d'urgence rapide et efficace pour contenir toute cybermenace."
        subtitle="Nous intervenons immédiatement pour limiter les dégâts, sécuriser vos systèmes et vous accompagner dans la résolution complète de l'incident."
        titleTranslationKey="incidentCyber.stats.title"
        subtitleTranslationKey="incidentCyber.stats.subtitle"
        stats={cyberIncidentStats}
        showChart={false}
      />
    </div>
  );
};

export default IntroSectionCyberIncident3;
